import React from 'react';
import Page from '../components/PageTemplate'
import TeamsText from '../data/TextAreaInput/TeamsText'

const Teams = () => {
    const titleSectionInput = {
        title: '',
        image: 'damlag2.jpg',
        bgTint1: "rgba(0, 37, 84, 0.2)",
        bgTint2: "rgba(0, 37, 84, 0.5)",
        bgTint3: "rgba(0, 37, 84, 0.8)"
    }
    return ( <
        Page titleSection = { titleSectionInput }
        textArea = { < TeamsText / > }
        />
    )
}

export default Teams